import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import DataMap from 'components/DataMap/DataMap';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  adminMap: {
    flex: 1,
    minHeight: '700px',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const ZipCodesDataMapView = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.adminMap}>
        <DataMap renderSearchZipcodesForm />
      </div>
    </div>
  );
};

export default ZipCodesDataMapView;
